'use es6';

import * as Operators from '../../../filterQueryFormat/operator/Operators';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { OrderedSet } from 'immutable';
export default {
  associatedcompanyid: {
    inputType: ENUMERATION,
    // https://git.hubteam.com/HubSpot/customer-data-filters/pull/354
    operators: OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown, Operators.EverEqual, Operators.NeverEqual)
  }
};